export default "__VITE_ASSET__rAiMNj$3__"